import { useSelector } from 'react-redux'
import { getPermissionGroups, HK_HOME_PATH, isMlnHk } from './reportForHkAccess'

export interface PermissionState {
  auth: { authUser: unknown }
  sysUser: {
    SysUserRecord: unknown
    profileOwnerSub: string | null
    profileSessionVersion: number
  }
}

export const usePermissionGroups = (): string | undefined => {
  const authUser = useSelector((state: PermissionState) => state.auth.authUser)
  const { SysUserRecord, profileOwnerSub } = useSelector(
    (state: PermissionState) => state.sysUser
  )
  const currentUser = localStorage.getItem('username')
  return authUser && currentUser && profileOwnerSub === currentUser
    ? getPermissionGroups(SysUserRecord)
    : undefined
}

export const useHomePath = (): string =>
  isMlnHk(usePermissionGroups()) ? HK_HOME_PATH : '/'
